module.exports = __webpack_public_path__ + "static/media/seat.b4e2ee0d.svg";